<template>
    <div class="principal">
        <NavBar :usarAberto="true" :usarHistorico="false" :usarVoltar="false" :usarDeslogar="true" :usarGerenciar="false"
            :usarRelatorio="false" :usarFiltroSetor="false" :usarFiltroTpChamado="false" :usarFiltroPosicao="false"
            :formatarDataInicioMes="formatarDataInicioMes" />

        <Modal id="ModalGerenciar" :mostrar="true" :usarHeader="false" :usarFooter="false">
            <template v-slot:corpo>
                <div class="d-flex btns">
                    <!-- <RouterLink class="btn btn-success" to="/profissionais">
                        Profissionais
                    </RouterLink> -->
                    <!-- <RouterLink class="btn btn-success" to="/responsavelSetor">
                        Responsável por Setor
                    </RouterLink> -->
                    <RouterLink class="btn btn-success" to="/cadastros">
                        Cadastros
                    </RouterLink>
                    <RouterLink class="btn btn-success" to="/PainelEquipamento">
                        Painel de Equipamento
                    </RouterLink>
                    <RouterLink class="btn btn-success" to="/Relatorios">
                        Relatórios
                    </RouterLink>
                    <button @click="limparPainel" class="btn btn-success">Limpar Painel</button>
                    <RouterLink class="btn btn-success" to="/PainelLeito">
                        Limpar Painel de Leito
                    </RouterLink>
                </div>
            </template>
            <!-- <template v-slot:rodape>
                <button @click="retAbertos" class="btn btn-success">Retornar aos abertos</button>
            </template> -->
        </Modal>

        <ModalConfirmaAgape :title="'ATENÇÃO'" :visible="state.comAviso" :text="state.aviso" :id="state.codigoLeito"
            @modalResult="modalConfirma">
            <template v-slot:motivo>
                <h4>Escreva o motivo abaixo</h4>
                <textarea class="form-control" v-model="state.motivo" cols="30" rows="2" maxlength="200"></textarea>
            </template>
        </ModalConfirmaAgape>

        <ModalEditar :mostrar="state.comMensagem" class="modal" :tamanhoModal="50">
            <template v-slot:header>
                <h2>Aviso</h2>
            </template>
            <template v-slot:corpo>
                <p>{{ state.mensagem }}</p>
            </template>
            <template v-slot:rodape>
                <div class="footer align-items-left">
                    <button @click="fechar" class="btn btn-secondary">Fechar</button>
                </div>
            </template>
        </ModalEditar>
    </div>
</template>

<script setup>
import Modal from '@/components/Modal.vue';
import store from '@/store/store';
import ModalConfirmaAgape from '@/components/ModalConfirmaAgape.vue';
import _versao from '@/../package.json';
import api from '@/api/api';
import ModalEditar from '@/components/ModalEditar.vue';
import NavBar from '@/components/NavBar.vue';
import router from '@/roteador/indexRoteador';
import { defineProps, reactive, computed } from 'vue';

const props = defineProps(['formatarDataInicioMes']);

const state = reactive({
    versao: _versao.version,
    mensagem: String(),
    comMensagem: Boolean(),
    comAviso: false,
    funcLimpar: false,
    aviso: "",
    motivo: "",
});

function deslogar() {
    sessionStorage.removeItem("TokenReguaPainel");
    router.back();
}

function retAbertos() {
    router.back();
}

async function limparPainel() {
    state.funcLimpar = true;
    state.aviso =
        "Deseja limpar todos os chamados abertos ? ";
    state.comAviso = true;
}

async function modalConfirma(result) {
    if (state.funcLimpar && result == "ok") {
        if (state.motivo.trim().length == 0) {
            state.mensagem = "Preencha o motivo antes de continuar";
            state.comMensagem = true;
            return;
        } else {
            await api.chamadoLimparLeito(state.motivo, 0)
                .then(resp => {
                    state.mensagem = "Status: " + resp + ", o painel foi limpo com sucesso";
                    state.comMensagem = true;
                })
                .catch(erro => {
                    state.mensagem = erro;
                    state.comMensagem = true;
                });
        }
    }

    state.funcLimpar = false;
    state.aviso = "";
    state.comAviso = false;
}

function fechar() {
    state.mensagem = String();
    state.comMensagem = false;
}

const tipoChamado = computed(() => {
    return store.state.tipoChamado;
});

const token = computed(() => {
    return (sessionStorage.TokenReguaPainel) ? true : false;
});
</script>

<style scoped>
.modal {
    margin-top: 13%;
}

.footer {
    width: 100%;
}

.btn {
    margin-bottom: 1rem;
}

.btns {
    flex-direction: column;
}
</style>